// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"e6369e24","291":"d13001c4","318":"13c851c4","413":"67d16dcf","567":"4c5bd1f8","651":"03228f65","683":"5b295825","720":"402809e9","749":"389008c8","760":"af181763","764":"96d568ef"}[chunkId] + ".chunk.js";
};